"use strict";
exports.__esModule = true;
var common_1 = require("../models/common");
var triggers = {
    words: common_1.markers.map(function (x) { return x.text; }),
    inflected: common_1.markers.map(function (x) { return x.text; })
};
var validateWords = function (reservedWordLists, value, field) {
    var words = common_1.tokenize(value);
    for (var _i = 0, reservedWordLists_1 = reservedWordLists; _i < reservedWordLists_1.length; _i++) {
        var reservedWordList = reservedWordLists_1[_i];
        if (reservedWordList.inflected.some(function (reservedWord) { return words.includes(reservedWord); })) {
            var quotedReservedWords = reservedWordList.words.map(function (x) { return "\u00AB" + x + "\u00BB"; }).join(', ');
            return field + " \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C " + quotedReservedWords;
        }
    }
    return '';
};
exports.validateReservedWordsAndPhrases = function (value, isAdmin, field) {
    if (field === void 0) { field = 'Поле'; }
    var wordLists = isAdmin ? [triggers] : [common_1.reservedWords, triggers];
    return validateWords(wordLists, value, field);
};
exports.validateReservedWords = function (value, field) {
    if (field === void 0) { field = 'Поле'; }
    return validateWords([common_1.reservedWords], value, field);
};
exports["default"] = exports.validateReservedWordsAndPhrases;
